export default __webpack_public_path__ + "static/media/cleaner.12f49ccd.png";